"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPublicSettingsLoadingStatus = exports.getPublicSettings = void 0;
function getPublicSettings(state) {
    if (state.editableSettings.publicSettings.data) {
        return state.editableSettings.publicSettings.data;
    }
    else {
        throw new Error('Public editable settings data is not available.');
    }
}
exports.getPublicSettings = getPublicSettings;
function getPublicSettingsLoadingStatus(state) {
    return state.editableSettings.publicSettings.status;
}
exports.getPublicSettingsLoadingStatus = getPublicSettingsLoadingStatus;
